var FilterableResult = require('../General/FilterableResult').FilterableResult;
import { AbconetApi } from '../General/AbconetApi';
import moment from "moment";

export class TechnicianTripListing extends React.Component {

    constructor(props) {
        super(props);
        this.filterableResult = React.createRef();
        this.state = {

        };
    }


    renderRows(row) {
        var serviceDate = row.serviceDate ? moment(row.serviceDate).format("DD/MM/YYYY") : "";

        return (
            <div className="item pl-0 pr-0" key={row.id}>
                <div className="row">
                    <div className="col-3 text-left">
                        {serviceDate}
                    </div>
                    <div className="col-3 text-center">
                        {row.name}
                    </div>
                    <div className="col-6 text-left">
                        {row.reportSummary}
                    </div>
                </div>
            </div>
        );
    }

    renderData(resultCollection) {
        return (
            <div className="list-group">
                <div className="row header">
                    <div className="col-3 col-hd text-left">
                        Date
                    </div>
                    <div className="col-3 col-hd text-center">
                        Technician
                    </div>
                    <div className="col-6 col-hd text-left">
                        Report Summary
                    </div>
                </div>

                {resultCollection.map(this.renderRows.bind(this))}
            </div>
        );
    }

    render() {
        var initialState = this.props.initialState;
        var baseUrl = null;

        if (this.props.limitToServiceJob != null) {
            initialState = {
                filterCollection: [{
                    "type": "Dropdown",
                    "value": this.props.limitToServiceJob.id,
                    "name": "serviceJobList",
                },
                    {
                        "type": "Dropdown",
                        "value": 18,
                        "name": "siteIdList",
                    }
                ],
                resultMetadata: {
                    pageSize: 5
                },

                hideFilter: true
            };
            baseUrl = "/techniciantrips/"
        }

        return (
            <div>
                <FilterableResult ref={this.filterableResult} initialState={initialState} renderData={this.renderData.bind(this)} baseUrl={baseUrl} />
            </div>
        );
    }

}